import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var it = {
  language: 'it',
  country: 'it',
  name: 'Italiano',
  embeddedLocale: merge(error, login),
  flags: ['IT'],
};

export { it as default };
